import ImageSwapDemo from '../ImageSwapDemo';
import AdminOrganisation from '../AdminOrganisation';
import PublishersDemoArticles from '../PublishersDemoArticles';
import PublishersDemoFMResult from '../PublishersDemoFMResult';
import PublishersDemoVideos from '../PublishersDemoVideos';
import UserAdd from '../UserAdd';
import UserEdit from '../UserEdit';
import Users from '../Users';
import OpusJobs from '../OpusJobs';

export default function AdminSections({ section, isDemo }) {
  return (
    <>
      {isDemo && section === 'video-swap' && (
        <ImageSwapDemo  />
      )}
      {section === 'organisations' && (
        <AdminOrganisation />
      )}
      {section === 'publishers-articles' && <PublishersDemoArticles />}
      {section === 'publishers-videos' && <PublishersDemoVideos />}
      {section === 'publishers-fast-match-result' && <PublishersDemoFMResult />}
      {section === 'user-add' && <UserAdd />}
      {section === 'user-edit' && <UserEdit />}
      {section === 'users' && <Users />}
      {section === 'opus-jobs' && <OpusJobs />}
    </>
  );
}
